"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const hopper_1 = require("services/daily-summary/hopper");
const hopper_types_1 = require("./hopper.types");
const getDataGrid = ({ dataStates, summaryMode }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hopper_1._getDailySummaryHopperData)(dataStates, summaryMode);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: hopper_types_1.dailySummaryHopperTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError
                ? []
                : response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { main_entrance_in: new Date(item.main_entrance_in), gate_in: new Date(item.gate_in), gate_out: new Date(item.gate_out) });
                }),
        };
        dispatch({ type: hopper_types_1.dailySummaryHopperTypes.SET_DATA_GRID, payload: payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: hopper_types_1.dailySummaryHopperTypes.ON_PAGE_CHANGE, payload });
});
const onFilterChange = (payload) => (dispatch) => {
    dispatch({ type: hopper_types_1.dailySummaryHopperTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = (payload) => (dispatch) => {
    dispatch({ type: hopper_types_1.dailySummaryHopperTypes.ON_SORT_CHANGE, payload });
};
const onLoading = () => (dispatch) => {
    dispatch({ type: hopper_types_1.dailySummaryHopperTypes.SET_LOADING, payload: true });
};
const onCloseError = () => (dispatch) => {
    dispatch({
        type: hopper_types_1.dailySummaryHopperTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false,
        },
    });
};
const onClickSummaryMode = (payload) => (dispatch) => {
    dispatch({ type: hopper_types_1.dailySummaryHopperTypes.ON_SUMMARY_MODE_CLICK, payload });
};
exports.default = {
    onLoading,
    getDataGrid,
    onCloseError,
    onSortChange,
    onFilterChange,
    onDataStateChange,
    onClickSummaryMode,
};
